import Vue from 'vue'
const Institution = {
  install: (Vue) => {
    const institution = new Vue({
      data: {
        institution: {}
      }
    })
    Vue.prototype.$institution = institution
  }
}
Vue.use(Institution)
